var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title1',{attrs:{"type":"2","title":"碳减排趋势"}}),_c('div',{staticStyle:{"width":"450px","height":"280px"}},[(_vm.showcdata)?_c('MyEcharts',{attrs:{"id":'options24hourse4333warn1122',"options":_vm.cdata}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }